var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMoreOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.875 10C7.97957 10 8.875 10.8954 8.875 12C8.875 13.1046 7.97957 14 6.875 14C5.77043 14 4.875 13.1046 4.875 12C4.875 10.8954 5.77043 10 6.875 10ZM12.875 10C13.9796 10 14.875 10.8954 14.875 12C14.875 13.1046 13.9796 14 12.875 14C11.7704 14 10.875 13.1046 10.875 12C10.875 10.8954 11.7704 10 12.875 10ZM20.875 12C20.875 10.8954 19.9796 10 18.875 10C17.7704 10 16.875 10.8954 16.875 12C16.875 13.1046 17.7704 14 18.875 14C19.9796 14 20.875 13.1046 20.875 12Z",
    fill: "#40DF9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoreOn);
export default __webpack_public_path__ + "static/media/icon-more-on.262a1eb1937f9a8f641a53664b35bda9.svg";
export { ForwardRef as ReactComponent };